<script setup lang="ts">
import type { CardStoryblok } from "~/storyblok/.generated/component-types";

defineProps<{
  blok: CardStoryblok;
}>();
</script>

<template>
  <CardBlock
    v-editable="blok"
    :title="blok.title"
    :description="blok.description"
    :image="blok.image"
    :link="blok.link"
    :link-text="blok.linkText"
  />
</template>
